export default {
    mounted(el) {
      if (el && el.textContent.includes('*')) {
        el.innerHTML = el.textContent.replace(/\*/g, '<span style="color: var(--app-error)!important"> *</span>');
      }
    },
    updated(el) {
      if (el && el.textContent.includes('*')) {
        el.innerHTML = el.textContent.replace(/\*/g, '<span style="color: var(--app-error)!important"> *</span>');
      }
    }
  };
